import { Box } from "@mui/material";
import ContainedButton from "../../components/buttons/ContainedButton";

export default function ContainedButtonDemo() {
  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Box display="flex" gap={2} alignItems="center">
        <ContainedButton onClick={() => {}} color="primary" size="large">
          Primary Large
        </ContainedButton>
        <ContainedButton onClick={() => {}} color="primary" size="medium">
          Medium
        </ContainedButton>
        <ContainedButton onClick={() => {}} color="primary" size="small">
          Small
        </ContainedButton>
        <ContainedButton onClick={() => {}} color="primary" size="xs">
          XS
        </ContainedButton>
      </Box>
      <Box display="flex" gap={2} alignItems="center">
        <ContainedButton onClick={() => {}} color="success" size="large">
          Success Large
        </ContainedButton>
        <ContainedButton onClick={() => {}} color="success" size="medium">
          Medium
        </ContainedButton>
        <ContainedButton onClick={() => {}} color="success" size="small">
          Small
        </ContainedButton>
        <ContainedButton onClick={() => {}} color="success" size="xs">
          XS
        </ContainedButton>
      </Box>
      <Box display="flex" gap={2} alignItems="center">
        <ContainedButton
          onClick={() => {}}
          color="primary"
          size="large"
          disabled={true}
        >
          Disabled Large
        </ContainedButton>
        <ContainedButton
          onClick={() => {}}
          color="primary"
          size="medium"
          disabled={true}
        >
          Medium
        </ContainedButton>
        <ContainedButton
          onClick={() => {}}
          color="primary"
          size="small"
          disabled={true}
        >
          Small
        </ContainedButton>
        <ContainedButton
          onClick={() => {}}
          color="primary"
          size="xs"
          disabled={true}
        >
          XS
        </ContainedButton>
      </Box>
      <Box display="flex" gap={2} alignItems="center">
        <ContainedButton
          onClick={() => {}}
          color="primary"
          size="large"
          loading={true}
        >
          Disabled
        </ContainedButton>
        <ContainedButton
          onClick={() => {}}
          color="primary"
          size="medium"
          loading={true}
        >
          Disabled
        </ContainedButton>
        <ContainedButton
          onClick={() => {}}
          color="primary"
          size="small"
          loading={true}
        >
          Disabled
        </ContainedButton>
        <ContainedButton
          onClick={() => {}}
          color="primary"
          size="xs"
          loading={true}
        >
          Disabled
        </ContainedButton>
      </Box>
    </Box>
  );
}
